import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import * as R from 'ramda';
import { BranchConstants } from 'src/constants';
import { HEALTH_PRODUCT_CLASS_NAME, RELATIONSHIP_CONNECTED_STATUS, SUBSCRIPTIONS_STATE_MAPPING } from 'src/constants/clientProfile';
import { AccountType, ORG_TYPE } from 'src/types';
import { OrderType, SortType } from 'src/types/sorting';
import { normalizePhone, sortByProp } from '.';
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(duration);
export var getNameFromClient = function getNameFromClient(client) {
  return R.path(['org_client_profiles', 0, 'real_name'], client) || R.path(['real_name'], client);
};
export var getPhoneFromClient = R.pathOr('', ['identities', 0, 'uid']);
export var getPhoneFromorgClientProfiles = function getPhoneFromorgClientProfiles(profies) {
  return R.path([0, 'mobile'], profies) || R.path([0, 'phone_number'], profies) || '';
};
export var getBirthdayFromProfiles = function getBirthdayFromProfiles(client) {
  return R.pathOr(R.prop('birthday', client), ['org_client_profiles', 0, 'birthday'], client);
};
export var isClinic = function isClinic() {
  return BranchConstants.ORG_TYPE === ORG_TYPE.CLINIC;
};
export var isChildClinic = function isChildClinic(serviceName) {
  return (serviceName === null || serviceName === void 0 ? void 0 : serviceName.includes('生長')) || false;
};
export var getAccountTypeFromGid = function getAccountTypeFromGid(gid) {
  if (gid.includes('User')) {
    return AccountType.user;
  } else if (gid.includes('Client')) {
    return AccountType.client;
  }

  return AccountType.client;
};
export var generateNewComment = function generateNewComment(senderProfile, record_id, value, type) {
  return {
    sender_id: senderProfile === null || senderProfile === void 0 ? void 0 : senderProfile.id,
    sender_type: getAccountTypeFromGid(senderProfile.gid),
    content: value,
    record_id: record_id,
    record_type: type
  };
};
export var getUserInfoFromClient = function getUserInfoFromClient(client, measurement) {
  var profile = R.pathOr({}, ['org_client_profiles', 0], client);
  return _objectSpread(_objectSpread(_objectSpread({
    yearsOld: dayjs().year() - dayjs(R.pathOr(0, ['birthday'], client)).year()
  }, R.pick(['gender', 'current', 'id'], client)), R.pickAll(['identity_number', 'record_number'], profile)), {}, {
    birthday: getBirthdayFromProfiles(client),
    height: R.pathOr(0, ['current', 'height'], client),
    bookingName: getBookingNameFromIdentities(R.pathOr([], ['identities'], client)),
    name: R.pathOr('', ['org_client_profiles', 0, 'real_name'], client) || R.pathOr('', ['name'], client),
    mobile: normalizePhone(R.pathOr('', ['org_client_profiles', 0, 'mobile'], client) || R.pathOr('', ['identities', 0, 'data', 'phone'], client)),
    inbody: {
      weight: R.pathOr('', ['data', 'weight'], measurement),
      body_fat_mass_percentage: R.pathOr('', ['data', 'body_fat_mass_percentage'], measurement),
      bmi: R.pathOr('', ['data', 'bmi'], measurement)
    }
  });
};
export var mapGroupClassOrder = function mapGroupClassOrder(item) {
  var groupClass = R.propOr({}, 'group_class', item);
  var firstName = R.pathOr('', ['user', 'first_name'], groupClass);
  var lastName = R.pathOr('', ['user', 'last_name'], groupClass);
  var classLeaderID = R.pathOr('', ['user', 'id'], groupClass);
  var started_at = R.pathOr('', ['started_at'], groupClass);
  var finished_at = R.pathOr('', ['finished_at'], groupClass);
  var state = R.pathOr('', ['program', 'name'], groupClass) === HEALTH_PRODUCT_CLASS_NAME ? null : R.pathOr('', ['aasm_state'], groupClass);
  var subscriptions = R.pipe(R.pathOr([], ['subscription_services']), R.filter(function (item) {
    var _item$relationship;

    return (item === null || item === void 0 ? void 0 : (_item$relationship = item.relationship) === null || _item$relationship === void 0 ? void 0 : _item$relationship.user_id) === classLeaderID;
  }))(groupClass);
  var leaves = R.pathOr([], ['subscription_service_leaves'], groupClass);
  var subscription = R.pipe(R.filter(function (leave) {
    return dayjs().isBetween(leave.start_date, leave.finish_date, 'day', '[]');
  }), R.length)(leaves) > 0 ? SUBSCRIPTIONS_STATE_MAPPING.left.key : R.pipe(R.map(function (item) {
    return item.aasm_state;
  }), R.head)(subscriptions);
  var currentWeekCount = Math.floor(dayjs.duration(dayjs().diff(dayjs(started_at))).asWeeks()) + 1;
  var masterDieticians = R.pipe(R.pathOr('', ['group_class_user_relations']), R.map(function (item) {
    var _item$user, _item$user2;

    return "".concat(item === null || item === void 0 ? void 0 : (_item$user = item.user) === null || _item$user === void 0 ? void 0 : _item$user.last_name).concat(item === null || item === void 0 ? void 0 : (_item$user2 = item.user) === null || _item$user2 === void 0 ? void 0 : _item$user2.first_name);
  }), R.join('、'))(groupClass);
  return {
    started_at: started_at,
    finished_at: finished_at,
    state: state,
    subscription: subscription,
    className: R.pathOr('', ['name'], groupClass),
    currentWeek: currentWeekCount,
    finished: dayjs(finished_at).endOf('day').isSameOrBefore(dayjs()),
    mainNutritionist: masterDieticians,
    classNutritionist: "".concat(lastName).concat(firstName),
    leavesInfo: R.map(function (item) {
      var days = dayjs.duration(dayjs(item.finish_date).diff(dayjs(item.start_date))).days();
      return {
        start: item.start_date,
        end: item.finish_date,
        days: days
      };
    }, leaves),
    program: R.pathOr('', ['plan'], item),
    programDuration: "".concat(started_at, " ~ ").concat(finished_at),
    programFood: ''
  };
};
export var mapGroupClassInfo = function mapGroupClassInfo(groupClass, t) {
  var leavesInfo = groupClass.leavesInfo;
  var leaves = leavesInfo.map(function (info) {
    return t('client_mgmt:normal.dateDuration', "".concat(info.start, "\u81F3").concat(info.end, "(\u5171").concat(info.days, "\u5929)"), {
      start: info.start,
      end: info.end,
      days: info.days
    });
  });
  return _objectSpread(_objectSpread({}, groupClass), {}, {
    leaves: leaves
  });
};
export var getRemainingDaysText = function getRemainingDaysText(remainingDiffDays, t) {
  return remainingDiffDays === 0 ? '' : remainingDiffDays < 0 ? t('client_mgmt:normal.finished', '已結束') : remainingDiffDays;
};
export var getClientAndGroupListFromRelationshipList = function getClientAndGroupListFromRelationshipList(relationshipList) {
  var clientList = R.pipe(R.filter(function (item) {
    return Boolean(R.prop('client', item));
  }), R.map(function (item) {
    return _objectSpread(_objectSpread(_objectSpread({}, item), item.client), {}, {
      relationshipId: item.id
    });
  }))(relationshipList);
  var groupList = R.pipe(R.filter(function (item) {
    return Boolean(R.prop('group_class', item));
  }), R.uniqBy(R.path(['group_class', 'id'])), R.map(function (item) {
    return _objectSpread(_objectSpread(_objectSpread({}, R.omit(['group_class', 'client', 'pinned', 'subscription_service_leaves', 'subscription_services'], item)), item === null || item === void 0 ? void 0 : item.group_class), {}, {
      list: R.pipe(R.filter(function (relationship) {
        var _relationship$group_c, _relationship$group_c2, _item$group_class;

        return !!((_relationship$group_c = relationship.group_class) !== null && _relationship$group_c !== void 0 && _relationship$group_c.id) && ((_relationship$group_c2 = relationship.group_class) === null || _relationship$group_c2 === void 0 ? void 0 : _relationship$group_c2.id) === (item === null || item === void 0 ? void 0 : (_item$group_class = item.group_class) === null || _item$group_class === void 0 ? void 0 : _item$group_class.id);
      }), R.map(function (item) {
        return _objectSpread(_objectSpread(_objectSpread({}, item), item.client), {}, {
          relationshipId: item.id
        });
      }))(relationshipList)
    });
  }))(relationshipList);
  return {
    clientList: clientList,
    groupList: groupList
  };
};
export var normalizeClientAndGroupList = function normalizeClientAndGroupList(searchText, orderType, sortType, clientList, groupList) {
  var clientWithoutGroup = R.pipe(R.filter(function (client) {
    return !R.prop('group_class', client);
  }), R.uniqBy(R.path(['client', 'id'])))(clientList);
  var pinnedClientList = R.filter(function (client) {
    return !!client.pinned;
  }, clientList);
  var nameProp = 'name';
  var timeProp = 'started_at';
  var isRelationshipConnected = R.propEq(RELATIONSHIP_CONNECTED_STATUS, 'status');
  var isGroupConnected = R.propEq(SUBSCRIPTIONS_STATE_MAPPING.started.key, 'aasm_state');

  var filterBySearchText = function filterBySearchText(item, searchText) {
    var _item$nameProp, _item$nameProp$toLowe;

    return !searchText || (item === null || item === void 0 ? void 0 : (_item$nameProp = item[nameProp]) === null || _item$nameProp === void 0 ? void 0 : (_item$nameProp$toLowe = _item$nameProp.toLowerCase()) === null || _item$nameProp$toLowe === void 0 ? void 0 : _item$nameProp$toLowe.includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) || (item === null || item === void 0 ? void 0 : item.id) == (searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase());
  };

  var extendClientList = clientList.filter(function (client) {
    var _client$subscription_;

    return isRelationshipConnected(client) && ((_client$subscription_ = client.subscription_service_leaves) === null || _client$subscription_ === void 0 ? void 0 : _client$subscription_.length) > 0 && (client === null || client === void 0 ? void 0 : client.group_class) && !isGroupConnected(client === null || client === void 0 ? void 0 : client.group_class);
  });
  var clientOrderType = sortType === SortType.byName ? orderType : OrderType.asc;
  var groupOrderType = orderType;
  var sortingPropForGroup = sortType === SortType.byName ? nameProp : timeProp;
  var sortingPropForClient = nameProp;

  var filterByConnectionStatusAndSearchText = function filterByConnectionStatusAndSearchText(item) {
    var needConnected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var isConnected = arguments.length > 2 ? arguments[2] : undefined;
    return needConnected === isConnected(item) && filterBySearchText(item, searchText);
  };

  var sortClient = sortByProp(sortingPropForClient, clientOrderType);
  var sortGroup = sortByProp(sortingPropForGroup, groupOrderType);

  var filterClients = function filterClients(needConnected) {
    return R.pipe(R.filter(function (client) {
      return filterByConnectionStatusAndSearchText(client, needConnected, isRelationshipConnected);
    }), sortClient);
  };

  var filterGroups = function filterGroups(needConnected) {
    return R.pipe(R.filter(function (group) {
      return filterByConnectionStatusAndSearchText(group, needConnected, isGroupConnected) || needConnected === isGroupConnected(group) && R.pipe(R.filter(function (client) {
        return filterBySearchText(client, searchText);
      }), R.complement(R.isEmpty))(group.list);
    }), sortGroup);
  };

  var connectedGroups = R.pipe(filterGroups(true), R.map(function (group) {
    return _objectSpread(_objectSpread({}, group), {}, {
      list: R.pipe(R.filter(function (client) {
        return isRelationshipConnected(client);
      }), R.uniqBy(R.path(['id'])))(group.list)
    });
  }))(groupList);
  var disconnectedGroups = R.pipe(filterGroups(false), // CS-1580 filter out clients with status 'connected' in disRelationshipConnected groups
  R.map(function (group) {
    return _objectSpread(_objectSpread({}, group), {}, {
      list: R.pipe(R.filter(function (client) {
        return !isRelationshipConnected(client);
      }), R.uniqBy(R.path(['id'])))(group.list)
    });
  }))(groupList);
  return [{
    key: 'inServices',
    i18n: 'client_mgmt:normal.studentsInService',
    text: '服務中',
    groups: connectedGroups,
    extend_clients: filterClients(true)(extendClientList),
    clients: filterClients(true)(clientWithoutGroup),
    pinnedClients: R.pipe(filterClients(true), R.uniqBy(R.path(['client', 'id'])))(pinnedClientList),
    clientsCountInAllGroups: R.pipe(R.chain(R.propOr([], 'list')), R.length)(connectedGroups)
  }, {
    key: 'completedService',
    text: '已結束',
    tooltip: '服務結束後 31 天內',
    tooltipI18n: 'client_mgmt:normal.within_31_days_after_service_ends',
    i18n: 'client_mgmt:normal.studentsCompletedService',
    groups: disconnectedGroups,
    clients: filterClients(false)(clientWithoutGroup),
    pinnedClients: R.pipe(filterClients(false), R.uniqBy(R.path(['client', 'id'])))(pinnedClientList),
    clientsCountInAllGroups: R.pipe(R.chain(R.propOr([], 'list')), R.length)(disconnectedGroups)
  }];
};
export var getBookingIdentity = function getBookingIdentity(identities) {
  return identities.find(function (identity) {
    return Boolean(identity === null || identity === void 0 ? void 0 : identity.provider) && BranchConstants.BOOKING_SOURCE_NAMES.includes(identity === null || identity === void 0 ? void 0 : identity.provider);
  });
};
export var getBookingNameFromIdentity = R.pathOr('', ['data', 'real_name']);
export var getBookingMobileFromIdentity = R.pathOr('', ['data', 'phone']);
export var getBookingNameFromIdentities = R.pipe(getBookingIdentity, getBookingNameFromIdentity);
export var getBookingMobileFromIdentities = R.pipe(getBookingIdentity, getBookingMobileFromIdentity);